module.exports = __webpack_public_path__ + "img/ill_spot_embargo.d1d68013.svg";